/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface DelegateRobloxSecretStoreAccessRequestContent
 */
export interface DelegateRobloxSecretStoreAccessRequestContent {
    /**
     * The API key which the developer made in the Roblox Create
Console which grants us permission to list and write In
their Secret Store.
     * @type {string}
     * @memberof DelegateRobloxSecretStoreAccessRequestContent
     */
    apiKey: string;
    /**
     * A unique identifier for the Roblox experience/universe.
     * @type {string}
     * @memberof DelegateRobloxSecretStoreAccessRequestContent
     */
    experienceId: string;
}


/**
 * Check if a given object implements the DelegateRobloxSecretStoreAccessRequestContent interface.
 */
export function instanceOfDelegateRobloxSecretStoreAccessRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "apiKey" in value;
    isInstance = isInstance && "experienceId" in value;
    return isInstance;
}

export function DelegateRobloxSecretStoreAccessRequestContentFromJSON(json: any): DelegateRobloxSecretStoreAccessRequestContent {
    return DelegateRobloxSecretStoreAccessRequestContentFromJSONTyped(json, false);
}

export function DelegateRobloxSecretStoreAccessRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegateRobloxSecretStoreAccessRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'apiKey': json['apiKey'],
        'experienceId': json['experienceId'],
    };
}

export function DelegateRobloxSecretStoreAccessRequestContentToJSON(value?: DelegateRobloxSecretStoreAccessRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'apiKey': value.apiKey,
        'experienceId': value.experienceId,
    };
}

